/**
 * @fileoverview Inbox route (MOR-716).
 *
 * URL: /dashboard/inbox
 *  - ?task=<jobKeyDates id> opens the task side panel
 *  - ?settings=1 opens the global notification settings dialog
 */

import { createFileRoute } from "@tanstack/react-router";
import { InboxPage } from "@/inbox/inbox-page";

export const Route = createFileRoute("/_app/_auth/dashboard/_layout/inbox")({
  validateSearch: (search: Record<string, unknown>) => ({
    task: typeof search.task === "string" ? search.task : undefined,
    settings:
      search.settings === 1 || search.settings === "1"
        ? (1 as const)
        : undefined,
  }),
  component: InboxPage,
});
